import { Router, ActivatedRoute } from "@angular/router";
import { MatDialog } from "@angular/material";
import { NewfolderComponent } from "../newfolder/newfolder.component";
import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";

import {
  FormArray,
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
} from "@angular/forms";
import { ToastService } from "ng-uikit-pro-standard";
import { DataService } from "src/app/data.service";

@Component({
  selector: "app-subfolder",
  templateUrl: "./subfolder.component.html",
  styleUrls: ["./subfolder.component.scss"],
})
export class SubfolderComponent implements OnInit {
  label: string;
  name: string;
  showFolderComponent: boolean = true;
  @Output() folderPropertiesChanged: EventEmitter<any> =
    new EventEmitter<any>();

  isLoading = false;
  isError = false;
  errorMessage = "";
  parentfolderId = "";
  parentfolderName = "";

  foldermode = "";
  folder = [];
  displayedColumns: string[] = [
    "name",
    "createdby",
    "parentfoldername",
    "createddate",
    "modifiedby",
    "modifieddate"
  ];
  dataSource: any;
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private toastrService: ToastService,
    private dataService: DataService,
    public dialog: MatDialog
  ) {}
  ngOnInit() {
    this.route.queryParams.subscribe((params) => {
      // this.mode = this.route.snapshot.params.mode;
      this.parentfolderId = this.route.snapshot.params.parentid;
      this.foldermode = this.route.snapshot.params.foldermode;
    });
    const currentUrl = this.router.url;
    const parts = currentUrl.split("/");
    const lastPart = parts[parts.length - 1];
    console.log(lastPart);
    this.parentfolderName = lastPart;
    console.log(this.parentfolderName);

    console.log(this.parentfolderId);
    this.getFolderById();
  }

  folders() {
    this.router.navigateByUrl("/home/reports");
  }

  updateFolderProperties(properties: any): void {
    this.label = properties.label;
    this.name = properties.name;

    this.folderPropertiesChanged.emit(properties);
  }
  newfolders() {
    const dialogRef = this.dialog.open(NewfolderComponent, {
      data: {
        label: this.label,
        name: this.name,
        foldermode: this.foldermode,
        parentfolderid: this.parentfolderId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("The section dialog was closed");
      if (result) {
        this.updateFolderProperties(result);
        console.log("result", result);
      }
    });
  }

  // navigateToFolders(parentFolderId: string) {
  //   this.router.navigateByUrl("/home/folder/sub/" + parentFolderId);
  // }
  navigateToFolders(parentFolderId: string, parentFolderName: string) {
    const currentUrl = this.router.url; // Get the current URL

    const newUrl =
      "/home/folder/sub/" + parentFolderId + "/" + parentFolderName;
    if (currentUrl === newUrl) {
      window.location.reload(); // Reload the page if the URL is the same
    } else {
      this.router.navigateByUrl(newUrl).then(() => {
        window.location.href = newUrl; // Refresh the browser
      });
    }
  }

  getFolderById() {
    return new Promise((resolve, reject) => {
      console.log("getFolderById");

      let postOption = {
        organizationid: localStorage.getItem("crm_orgid"),
        // domain: localStorage.getItem("domain"),
        // subdomain: localStorage.getItem("subdomain"),
        domain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.domain`),
        subdomain: localStorage.getItem(`${localStorage.getItem("crm_orgid")}.subdomain`),
        data: {
          folder: {
            id: this.parentfolderId,
          },
        },
      };
      console.log("postOption", postOption);
      this.isLoading = true;
      this.dataService.getFolderById(postOption).subscribe(
        (res) => {
          console.log("res", res);

          if (res.success == 1) {
            // this.process = res.data.process;
            // console.log("Doneeee****", this.process);

            this.folder = res.data.folder;
            if (this.folder != null) {
              this.dataSource = this.folder.map((folder) => ({
                id: folder.id,
                name: folder.name,
                modifiedby: folder.modifiedby,
                modifieddate: folder.modifieddate,
                createdby: folder.createdby,
                createddate: folder.createddate,
                parentid: folder.parentfolderid,
                // parentfoldername: this.parentfolderName,
              }));
            }

            this.isLoading = false;
          } else {
            console.log("Error while Retrieving");
            this.isLoading = false;
          }
        },
        (err) => {
          console.log("Error***:", err);
          this.errorMessage = err.message;
          this.isError = true;
          this.isLoading = false;
          resolve(null);
        }
      );
    });
  }
}
